<div class="flex flex-wrap">
    <div class="w-full">
        <hr />
    </div>
</div>

<style>
    hr {
        height: 1px;
        border: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    }
</style>
